var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisalogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 50,
    viewBox: "0 0 79 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4242 12.2773C45.8311 12.2773 40.8328 15.1681 40.8328 20.5089C40.8328 26.6339 49.6975 27.0569 49.6975 30.1339C49.6975 31.4295 48.2084 32.5892 45.6653 32.5892C42.056 32.5892 39.3585 30.9688 39.3585 30.9688L38.2042 36.3583C38.2042 36.3583 41.3118 37.7271 45.4375 37.7271C51.5526 37.7271 56.3644 34.6945 56.3644 29.2622C56.3644 22.7902 47.4629 22.3797 47.4629 19.5238C47.4629 18.5088 48.6852 17.3967 51.2211 17.3967C54.0823 17.3967 56.4167 18.5753 56.4167 18.5753L57.5463 13.37C57.5463 13.37 55.0063 12.2773 51.4242 12.2773ZM0.252624 12.6702L0.117188 13.4559C0.117188 13.4559 2.47022 13.8853 4.58951 14.742C7.3183 15.7241 7.5126 16.296 7.97226 18.072L12.9801 37.322H19.6932L30.0353 12.6702H23.3376L16.6922 29.431L13.9805 15.2238C13.7317 13.5978 12.4721 12.6702 10.9302 12.6702H0.252624ZM32.7285 12.6702L27.4744 37.322H33.8612L39.0969 12.6702H32.7285ZM68.3501 12.6702C66.81 12.6702 65.994 13.4925 65.3952 14.9291L56.0381 37.322H62.7358L64.0316 33.5898H72.1914L72.9793 37.322H78.8892L73.7335 12.6702H68.3501ZM69.2211 19.3303L71.2065 28.5809H65.8877L69.2211 19.3303Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisalogo);
export default __webpack_public_path__ + "static/media/visalogo.a163c3b5bdbd8a1f49c7dd70ffd4e0c4.svg";
export { ForwardRef as ReactComponent };